export default __webpack_public_path__ + "static/YrsaSemiBold-ecf413bb43ac0cbe1d03f47f05813e10.woff2";